export const labelColor = (type: string, bg = false): string => {
  if (type === 'approved') {
    return bg ? "#e7fee8" : "#0f9655"
  }
  if (type === 'completed') {
    return bg ? "#DBE8FC" : "#6C8EBF"
  }
  if (type === 'unapplied' || type === 'returned' || type === 'dropped' || type === 'canceled') {
    return bg ? "#ffeaea" : "#FF0000"
  }
  if (type === 'processing' || type === 'skipped') {
    return bg ? "#fffeea" : "#d47e13"
  }
  if (type === 'all') {
    return bg ? "#FFFFFF" : "#666666"
  }
  return bg ? "#FFFFFF" : "#666666"
}

export const statusText = (status: string): string => {
  if (status === "approved") {
    return "承認済み"
  }
  if (status === "completed") {
    return "承認完了"
  }
  if (status === "processing") {
    return "申請中"
  }
  if (status === "skipped") {
    return "スキップ"
  }
  if (status === "unapplied" || status === "canceled") {
    return "未申請"
  }
  if (status === "returned") {
    return "差戻し"
  }
  if (status === "dropped") {
    return "承認取消"
  }
  if (status === "all") {
    return "全て"
  }
  return ""
}
